"use strict";

var config = require('config');
(function () {
  "use strict";

  angular.module("fleetviewApp").controller("tidLoginController", tidLoginController);

  tidLoginController.inject = ["$rootScope", "$scope", "Messages", "$location", "tidLoginService", "alkAuthenticationService", "$q", "UserProvider"];
  function tidLoginController($rootScope, $scope, Messages, $location, tidLoginService, alkAuthenticationService, $q, UserProvider) {

    var vm = this;
    vm.formTab = "login";
    vm.isProcessing = false;
    vm.baseurl = window.location.protocol + "//" + window.location.host;
    vm.tidConfig = {
      eventHandler: function eventHandler(event) {

        switch (event.type) {
          case "SIGN_IN_USERNAME":
            {
              $scope.handleSignInUsername(event);
              break;
            }
          case "SIGN_IN_LEGACY":
            {
              $scope.handleSignInLegacy();
              break;
            }
          case "SIGN_IN_TID":
            {
              $scope.handleSignInTid(event);
              break;
            }
          case "SIGN_IN_PASSWORD":
            {
              $scope.handleSignInPassword(event);
              break;
            }
          case "SIGN_IN_CONFIRM_CANCEL":
            {
              $scope.handleSignInCancel();
              break;
            }
          case "SIGN_IN_ACCOUNT":
            {
              if ($scope.useTidSSOLogin === true) {
                $scope.tidSSOlogin(event.account);
              } else {
                $scope.handleSignInPassword(event);
              }
            }
        }
      } };

    $rootScope.$on("forgotPassword", function (msg) {
      vm.formTab = "forgot";
    });

    $scope.$watch("vm.formTab", function (newValue, oldValue) {
      if (newValue !== oldValue) {
        Messages.clear();
      }
    });

    $scope.authCode = $location.search().code;
    $scope.useTidSSOLogin = true;
    $scope.showGenericError = false;
    $scope.showPasswordIncorrect = false;
    $scope.showNoAccountForApplication = false;
    $scope.failedToLoginAccountExpired = false;
    $scope.failedToValidateTidToken = false;
    $scope.failedToFindUserInAccount = false;
    $scope.showAccountDisabled = false;
    $scope.userDoesNotExist = false;
    $scope.noAccess = false;

    var tmxTidService = tmxtidmodule.init(vm.tidConfig);
    localStorage.removeItem("idToken");

    $scope.handleSignInUsername = function (tidEvent) {
      tidLoginService.getTidMigrationStatus(tidEvent.username).then(function (resp) {
        if (resp.data.exists === false) {
          $scope.userDoesNotExist = true;
          tmxTidService.showSignInUsername();
        } else if (resp.data.migrated === true && resp.data.exists === true) {
          redirectToTid(tidEvent.username, "login");
          $scope.userDoesNotExist = false;
        } else {
          $scope.showGenericError = false;
          $scope.showPasswordIncorrect = false;
          $scope.showNoAccountForApplication = false;
          $scope.failedToLoginAccountExpired = false;
          $scope.failedToValidateTidToken = false;
          $scope.failedToFindUserInAccount = false;
          $scope.showAccountDisabled = false;
          $scope.userDoesNotExist = false;
          tmxTidService.showSignInConfirm();
        }
      });
    };

    $scope.handleSignInCancel = function () {
      tmxTidService.showSignInUsername();
    };

    $scope.handleSignInLegacy = function () {
      $scope.useTidSSOLogin = false;
      tmxTidService.showSignInPassword();
    };

    $scope.handleSignInTid = function (tidEvent) {
      redirectToTid(tidEvent.username, "create");
    };

    $scope.handleSignInPassword = function (tidEvent) {
      var userInfo = {
        account: tidEvent.account,
        password: tidEvent.password,
        username: tidEvent.username
      };
      alkAuthenticationService.login(userInfo).then(function (response) {
        window.location.replace(vm.baseurl + "/app/dashboard");
      }).catch(function (error) {
        switch (true) {
          case error.status === "FailedToLoginDueToMultipleAccounts":
            {
              var accountDisplayObjs = createSelectAccountObjs(error.accounts);
              tmxTidService.showSignInAccounts(accountDisplayObjs);
              break;
            }
          case error.status === "FailedToLoginNotAuthorized":
            {
              $scope.showNoAccountForApplication = true;
              tmxTidService.showSignInUsername();
              break;
            }
          case error.status === "LoginNotExist":
            {
              $scope.showPasswordIncorrect = true;
              tmxTidService.showSignInUsername();
              break;
            }
          case error.status === "FailedToLogin":
            {
              $scope.showPasswordIncorrect = true;
              tmxTidService.showSignInUsername();
              break;
            }
          case error.isAccountDisabled === true:
            {
              $scope.showAccountDisabled = true;
              tmxTidService.showSignInUsername();
              break;
            }
          default:
            {
              $scope.showGenericError = true;
              tmxTidService.showSignInUsername();
            }
        }
      });
    };

    $scope.tidSSOlogin = function login(account) {
      var deferred = $q.defer();
      tidLoginService.tidSSOLogin(account, $scope.authCode).success(function (resp) {
        window.localStorage.setItem("idToken", resp.idToken);
        var authToken = resp.authToken,
            username = resp.username,
            accountName = resp.accountName,
            forcePasswordReset = resp.forcePasswordReset;

        alkAuthenticationService.getUserInfo(authToken, username, accountName, forcePasswordReset).then(function (userInfo) {
          UserProvider.loadUser(userInfo.user);
          window.location.replace(vm.baseurl + "/app/dashboard");
        });
      }).error(function (error) {
        switch (error.status) {
          case "FailedToLoginDueToMultipleAccounts":
            {
              var accountDisplayObjs = createSelectAccountObjs(error.accounts);
              tmxTidService.showSignInAccounts(accountDisplayObjs);
              break;
            }
          case "FailedToLoginNotAuthorized":
            {
              $scope.showNoAccountForApplication = true;
              tmxTidService.showSignInUsername();
              break;
            }
          case "LoginNotExist":
            {
              $scope.showPasswordIncorrect = true;
              tmxTidService.showSignInUsername();
              break;
            }
          case "FailedtoLogin":
            {
              $scope.showPasswordIncorrect = true;
              tmxTidService.showSignInUsername();
              break;
            }
          case "FailedToLoginAccountExpired":
            {
              $scope.failedToLoginAccountExpired = true;
              tmxTidService.showSignInUsername();
              break;
            }
          case "FailedToValidateTrimbleIdentityToken":
            {
              $scope.failedToValidateTidToken = true;
              tmxTidService.showSignInUsername();
              break;
            }
          case "NoAccess":
            {
              $scope.noAccess = true;
              tmxTidService.showSignInUsername();
              break;
            }
          case "FailedToFindUserInAccount":
            {
              $scope.failedToFindUserInAccount = true;
              tmxTidService.showSignInUsername();
              break;
            }
          default:
            {
              $scope.showGenericError = true;
              tmxTidService.showSignInUsername();
            }
        }
      });

      return deferred.promise;
    };

    if ($scope.authCode) {
      // After Tid login redirects back to app, log into SSO
      $scope.tidSSOlogin(null);
    }

    function redirectToTid(emailAccount, prompt) {
      var url = config.trimbleCloudUrl + "oauth/authorize";
      url += "?client_id=" + config.trimbleCloudClientId;
      url += "&response_type=code";
      url += "&scope=openid " + config.trimbleApplication;
      url += "&redirect_uri=" + vm.baseurl + "/tid/redirect";
      url += "&prompt=" + prompt;
      url += "&login_hint=" + encodeURIComponent(emailAccount);
      window.location.href = url;
    }

    function createSelectAccountObjs(accounts) {
      var accountDisplayObjs = [];
      for (var i = 0; i < accounts.length; i++) {
        accountDisplayObjs.push({
          displayName: accounts[i].accountName,
          value: accounts[i].accountName
        });
      }
      return accountDisplayObjs;
    }
  }
})();


// WEBPACK FOOTER //
// ./app/auth/tidLogin.controller.js